(ns frontend.ux-overhaul.listing.generic.header
  "The header row of a listing. The title, the search field, the controls, the
   actions and the menu are in one row, as they are on the Dealflow page of the UX
   mockup. The search field takes the width that the other parts leave.")

(def row-class
  "The row has no divider below it, as in the mockup: 16 px at the sides, 12 px
   above and 8 px below. The parts are in one line on a screen that is at least
   820 px wide. The shortest title, the search field (8 rem) and the controls need
   about 810 px. On a narrower screen the parts wrap. `flex-wrap` and
   `min-[820px]:flex-nowrap` are classes of the old style sheet: a breakpoint
   variant of the tw2 style sheet never matches, see
   the entry of 2026-10-22 about breakpoint variants in ai/mistakes.md."
  "bg-base-light flex-wrap min-[820px]:flex-nowrap tw2-flex tw2-w-full tw2-items-center tw2-gap-2 tw2-px-4 tw2-pb-2 tw2-pt-3")

(def title-class
  "A long title ends with an ellipsis after 16 rem. The title is the part that
   shrinks first, down to 5 rem, so that the search field keeps its width. The
   mockup has 12 rem, 16 rem from the `sm` breakpoint, and a title that does not
   shrink. The tw2 `sm` variant never matches, so the title has the 16 rem on every
   screen."
  "tw2-flex tw2-min-w-[5rem] tw2-max-w-[16rem] tw2-shrink tw2-items-center tw2-font-semibold")

(def search-class
  "The search field fills the rest of the row, and it keeps a minimum width of 8 rem."
  "tw2-min-w-[8rem] tw2-flex-1")

(def actions-class
  "The parts on the right, for example the filter count. The group has no gap when
   it is empty."
  "tw2-flex tw2-shrink-0 tw2-items-center tw2-gap-2 empty:tw2-hidden")

(def menu-class
  "tw2-shrink-0")

(defn row
  "Return the header row of a listing.

   `:title` is the hiccup of the title, or nil. A listing with no title has no
   title cell.
   `:search` is the hiccup of the search field. It takes the remaining width.
   `:controls` is a vector of the controls, in order. Each control keeps its own
   width. A nil in the vector is ignored.
   `:actions` is a vector of the parts on the right, for example the filter count.
   The cell is hidden when all of them are nil. The actions on a selection are not
   here: they are in the selection pill at the bottom of the listing.
   `:menu` is the hiccup of the menu at the end of the row, or nil."
  [{:keys [title search controls actions menu]}]
  (-> [:div {:class row-class}]
      (into (when title
              [[:div {:class title-class}
                title]]))
      (conj [:div {:class search-class}
             search])
      (into controls)
      (conj (into [:div {:class actions-class}]
                  actions))
      (into (when menu
              [[:div {:class menu-class}
                menu]]))))
